module.exports = __webpack_public_path__ + "static/flags/CQ-a8f69a144607245a071ab160939550d1.gif";